export default __webpack_public_path__ + "static/media/kettle.a9d38d64.svg";